import { inject } from '@angular/core';
import { UserService } from '../service/user.service';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  if(userService.isConnected()){
    return true;
  } else {
    router.navigate(["/login"]);
    return false;
  }

  return true;

};
